import { Control, FieldPath, FieldValues } from 'react-hook-form';
import { Toggle } from '../../../../../../web/components/Toggle';
import { grayIconFill } from '../../../../../../web/styles/colors';
import { FormFieldWrapper } from '../FormFieldWrapper';

interface ShowSurveyNameToggleProps<TFieldValues extends FieldValues> {
	control: Control<TFieldValues>;
	description: string;
	disabled?: boolean;
	id: string;
	name: FieldPath<TFieldValues>;
}

export const ShowSurveyNameToggle = <TFieldValues extends FieldValues>({
	control,
	description,
	disabled = false,
	id,
	name,
}: ShowSurveyNameToggleProps<TFieldValues>) => (
	<FormFieldWrapper<TFieldValues> name={name} control={control} title='Show Survey Name' description={description}>
		{({ value, onChange }) => {
			const isOn = value === true;

			return (
				<Toggle
					id={id}
					isOn={isOn}
					disabled={disabled}
					onToggleCheckChanged={() => onChange(!isOn)}
					uncheckedColor={grayIconFill}
				/>
			);
		}}
	</FormFieldWrapper>
);
